import { get } from 'lodash';

import { Work } from './work-data-store';

export const title = (work: Work) => get(work, 'title');

export const preferredTitle = (work: Work) => {
    const titles = get(work, 'identificationWorkSchema.workTitle', []) || [];
    const principalTitle = titles.find(t => t.principal === true);

    return principalTitle.title || titles[0];
};

export const creationDates = (work: Work) =>
    get(work, 'descriptionWorkSchema.creationDates', []) || [];

export const aliases = (work: Work) =>
    (get(work, 'descriptionWorkSchema.credits', []) || []).map(credit => credit.alias);
